import classNames from 'classnames';
import { type PropsWithChildren } from 'react';

import s from './Table.module.scss';

type Props = {
  className?: string;
  disableScroll?: boolean;
};

const Table: React.FC<PropsWithChildren<Props>> = ({ children, className, disableScroll }) => (
  <div
    className={classNames(s.container, 'table-scrollbar')}
    {...(disableScroll && {
      style: {
        overflowX: 'unset',
      },
    })}
  >
    <table className={className} cellSpacing='0' cellPadding='0'>
      {children}
    </table>
  </div>
);

export default Table;
